import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import facebook from "./assets/facebook.svg?inline";
import twitter from "./assets/twitter.svg?inline";
import linkedin from "./assets/linkedin.svg?inline";
import instagram from "./assets/instagram.svg?inline";
import youtube from "./assets/youtube.svg?inline";

import SVGInline from "react-svg-inline";

const SocialMedia = () => {
  return (
    <ul className="icon-list">
      <li>
        <Link to="https://facebook.com">
          <div title="Facebook">
            <SVGInline svg={facebook} />
          </div>
        </Link>
      </li>
      <li>
        <Link to="https://twitter.com">
          <div title="Twitter">
            <SVGInline svg={twitter} />
          </div>
        </Link>
      </li>
      <li>
        <Link to="https://linkedin.com">
          <div title="Linkedin">
            <SVGInline svg={linkedin} />
          </div>
        </Link>
      </li>
      <li>
        <Link to="https://instagram.com">
          <div title="Instagram">
            <SVGInline svg={instagram} />
          </div>
        </Link>
      </li>
      <li>
        <Link to="https://youtube.com">
          <div title="Youtube">
            <SVGInline svg={youtube} />
          </div>
        </Link>
      </li>
    </ul>
  );
};

export default SocialMedia;
